import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Card, Overline, StatCard, ProgressBar, Pill, Icon, PageLoader, SectionTitle } from "../../components/ui-kit";
import { cn } from "../../lib/utils";

export default function SchoolDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/school/dashboard").then(({ data }) => setD(data)); }, []);
  if (!d) return <PageLoader />;

  return (
    <div className="max-w-6xl mx-auto p-4 sm:p-6 space-y-6">
      <div className="relative rounded-[28px] p-6 sm:p-7 text-white overflow-hidden" style={{ background: "linear-gradient(135deg,#33c7e2,#0f97b3)" }}>
        <div className="absolute inset-0 dotgrid opacity-50" />
        <Icon name="Building2" className="absolute -right-4 -bottom-5 w-36 h-36 opacity-15" />
        <div className="relative"><Overline className="text-white/80">School Control Centre</Overline><h1 className="text-3xl sm:text-4xl font-bold mt-1 tracking-tight">{d.school?.name}</h1></div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard icon="Users" label="Students" value={d.total_students} tone="blue" />
        <StatCard icon="Presentation" label="Teachers" value={d.total_teachers} tone="green" />
        <StatCard icon="Award" label="Avg Performance" value={`${d.avg_performance}%`} tone="purple" />
        <StatCard icon="CalendarCheck" label="Attendance" value={`${d.attendance}%`} tone="cyan" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard icon="Activity" label="Engagement" value={`${d.engagement}%`} tone="yellow" />
        <StatCard icon="FileStack" label="Content Published" value={d.content_published} tone="blue" />
        <StatCard icon="ClipboardCheck" label="Tests" value={d.tests} tone="coral" />
        <StatCard icon="School" label="Classes" value={d.classes} tone="green" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Card>
          <SectionTitle title="Subject Performance" icon="BarChart3" />
          <div className="space-y-3.5">
            {d.subject_performance.map((s) => (
              <div key={s.name}>
                <div className="flex justify-between text-sm mb-1.5"><span className="font-semibold text-mim-navy">{s.name}</span><span className="text-mim-navy font-semibold">{s.mastery}%</span></div>
                <ProgressBar value={s.mastery} color={s.color} />
              </div>
            ))}
          </div>
        </Card>
        <div className="space-y-6">
          <Card>
            <SectionTitle title="Alerts" icon="Bell" />
            <div className="space-y-3">
              {d.alerts.map((a) => (
                <div key={a.id} className={cn("flex items-start gap-2.5 p-3 rounded-2xl", a.type === "risk" ? "bg-mim-coral/5" : "bg-mim-yellow/10")}>
                  <Icon name={a.type === "risk" ? "TriangleAlert" : "ClipboardCheck"} className={cn("w-4 h-4 mt-0.5 shrink-0", a.type === "risk" ? "text-mim-coral" : "text-[#b07d13]")} />
                  <p className="text-sm text-mim-navy">{a.text}</p>
                </div>
              ))}
            </div>
          </Card>
          <Card>
            <SectionTitle title="Top Performers" icon="Trophy" />
            <div className="space-y-2">
              {d.top_performers.map((s, i) => (
                <div key={s.name} className="flex items-center gap-3">
                  <span className={cn("w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold", i===0?"bg-mim-yellow/20 text-[#b07d13]":"bg-slate-100 text-mim-muted")}>{i+1}</span>
                  <span className="flex-1 text-sm font-medium text-mim-navy">{s.name}</span>
                  <Pill tone="green">{s.mastery}%</Pill>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
      <Card className="bg-mim-soft border-mim-blue/15 flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3"><Icon name="Wand2" className="w-5 h-5 text-mim-blue" /><span className="font-semibold text-mim-navy">Generate curriculum for your school with AI</span></div>
        <Link to="/teacher/curriculum" className="text-sm font-semibold text-mim-blue hover:underline">Open Curriculum Factory →</Link>
      </Card>
    </div>
  );
}
